// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"165e3d63ced47cf2","442":"f266e5c73f3f1e41","471":"cfcaced19b7e0581","711":"5d6cf1f319d25163"}[chunkId] + ".js";
};